import UserModel from './UserModel'

export default (comment) => {
  if (!comment) return

  if (comment.user) {
    comment.user = UserModel(comment.user)
  }

  return Object.defineProperties(comment, {})
}



// WEBPACK FOOTER //
// ./src/services/Models/CommentModel.js